<div class="relative flex flex-col justify-center w-full h-screen dark:bg-gray-900 sm:p-0 lg:flex-row">
  <div class="flex flex-col flex-1 w-full lg:w-1/2">
    <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
      <div>
        <div class="mb-5 sm:mb-8">
          <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
            Recover your password
          </h1>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Forgotten your password, or never set one? Enter your email address and we'll send you a link to set a new one.
          </p>
        </div>
        <div>
          <!-- Success Message -->
          @if (success) {
            <div class="mb-5 p-4 rounded-lg bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800">
              <div class="flex items-center">
                <svg class="flex-shrink-0 w-5 h-5 text-green-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <p class="text-sm font-medium text-green-700 dark:text-green-400">{{ success }}</p>
              </div>
            </div>
          }

          <!-- Error Message -->
          @if (error) {
            <div class="mb-5 p-4 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
              <div class="flex items-center">
                <svg class="flex-shrink-0 w-5 h-5 text-red-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
                <p class="text-sm font-medium text-red-700 dark:text-red-400">{{ error }}</p>
              </div>
            </div>
          }

          <form (ngSubmit)="submit()">
            <div class="space-y-5">
              <!-- Email -->
              <div>
                <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                  Email<span class="text-error-500">*</span>
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  [disabled]="submitting"
                  [(ngModel)]="email"
                  placeholder="name@example.com"
                  class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
                />
              </div>

              <!-- Button -->
              <div>
                <button
                  type="submit"
                  [disabled]="submitting || !email"
                  [ngClass]="{
                    'bg-brand-500': !submitting && email,
                    'bg-gray-300 dark:bg-gray-700': submitting || !email
                  }"
                  class="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg shadow-theme-xs hover:bg-brand-600"
                >
                  @if (submitting) {
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Sending...
                  } @else {
                    Send me a link
                  }
                </button>
              </div>

              <!-- Back to Login -->
              <div class="text-center">
                <a
                  [routerLink]="['/login']"
                  class="text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400"
                >
                  Back to sign in
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="relative items-center hidden w-full h-full bg-brand-950 dark:bg-white/5 lg:grid lg:w-1/2">
    <div class="flex items-center justify-center z-1">
      <div class="flex flex-col items-center max-w-xs">
        <a href="index.html" class="block mb-4">
          <img [ngSrc]="logoUrl" priority alt="Logo" height="100" width="400"/>
        </a>
        <p class="text-center text-gray-400 dark:text-white/60">
          The Venue Group
        </p>
      </div>
    </div>
  </div>
</div>
